// extracted by mini-css-extract-plugin
export var cancelButton = "_ly-5";
export var content = "_ly-3";
export var createButton = "_ly-6";
export var drawerContainer = "_ly-0";
export var footer = "_ly-2";
export var header = "_ly-1";
export var orderFormColumn = "_ly-4";